import { render, staticRenderFns } from "./exclusions.vue?vue&type=template&id=4d021b2a&scoped=true"
import script from "./exclusions.vue?vue&type=script&lang=js"
export * from "./exclusions.vue?vue&type=script&lang=js"
import style0 from "./exclusions.vue?vue&type=style&index=0&id=4d021b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d021b2a",
  null
  
)

export default component.exports